<template>
    <p
        v-if="lines.length"
        class="text-multiline"
        :class="getBemModifiers()"
    >
        <template v-for="line in lines">
            {{ line }} <br class="break-line" /> <!-- eslint-disable-line -->
        </template>
    </p>
</template>

<script>
import { parseNewLinesToArray } from '~/src/utils/text';

export default {
    name: 'TextMultiline',
    availableBemModifiers: ['address', 'line-height-normal', 'no-break-mobile', 'no-break-desktop'],
    props: {
        /**
         * plain text with end of line tags
         */
        plainText: {
            type: String,
            default: '',
        },
    },
    computed: {
        /**
         * divide text by end of line tags
         *
         * @returns {Object}
         */
        lines() {
            return parseNewLinesToArray(this.plainText);
        },
    },
};
</script>

<style lang="scss">
    .text-multiline {
        font-family: $goodHomeFontFamily;
        line-height: 22px;
        word-wrap: break-word;
        color: $color-slate;
        display: inline-block;
        width: 100%;

        @include font-modifiers;

        &--address {
            font-weight: $font-weight-regular;
            font-size: 14px;
            line-height: 20px;
            color: $color-slate100;
        }

        &--line-height-normal {
            line-height: 16px;
        }

        &--no-break-mobile {
            .break-line {
                display: none;
            }
        }
    }

    @media screen and (min-width: $mf-breakpoint-tablet) {
        .text-multiline {
            line-height: 24px;
            font-size: 14px;

            &--address {
                font-size: 14px;
                line-height: 20px;
            }

            &--line-height-normal {
                line-height: 16px;
            }

            &--no-break-desktop {
                .break-line {
                    display: none;
                }
            }
        }
    }
</style>
